function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.28125 16.7108L16.063 3.92901L23.4903 11.3563L10.7085 24.138L3.28125 16.7108Z",
  fill: "#ECECEC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1428 16.2804C13.1938 18.3313 13.1938 21.6566 11.1428 23.7076C9.09185 25.7586 5.76656 25.7586 3.71558 23.7076C1.6646 21.6566 1.6646 18.3313 3.71558 16.2804C5.76655 14.2294 9.09185 14.2294 11.1428 16.2804Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4905 3.92932C25.5415 5.9803 25.5415 9.30559 23.4905 11.3566C21.4395 13.4075 18.1142 13.4075 16.0632 11.3566C14.0123 9.30559 14.0123 5.9803 16.0632 3.92932C18.1142 1.87834 21.4395 1.87834 23.4905 3.92932Z",
  fill: "white"
});

function SvgLogoAlternative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAlternative);
export default __webpack_public_path__ + "static/media/logo-alternative.077c0a8f.svg";
export { ForwardRef as ReactComponent };